(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["image-protection"] && !Shopify.designMode) return;
  try {
    document.addEventListener('contextmenu', (event) => {
    if (event.target.tagName === 'IMG') event.preventDefault();
  });

  document.addEventListener('dragstart', (event) => {
    if (event.target.tagName === 'IMG') event.preventDefault();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-block"] && !Shopify.designMode) return;
  try {
    class VideoBlockPlayer extends HTMLElement {
    connectedCallback() {
      this.asGif = this.dataset.asGif === 'true';

      if (this.asGif) {
        // Modo GIF: recién se monta y reproduce el video cuando el bloque
        // está por entrar en pantalla, para no gastar datos en algo fuera de vista.
        this.observer = new IntersectionObserver(this.onIntersect.bind(this), { rootMargin: '200px' });
        this.observer.observe(this);
      } else {
        this.querySelector('button')?.addEventListener('click', this.playVideo.bind(this));
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    onIntersect(entries) {
      if (!entries[0].isIntersecting) return;
      this.observer.disconnect();
      this.mountVideo({ autoplay: true, muted: true, loop: true, controls: false });
    }

    playVideo() {
      this.mountVideo({ autoplay: true, muted: false, loop: false, controls: true });
    }

    mountVideo(options) {
      const template = this.querySelector('template');
      if (!template) return;

      const video = template.content.firstElementChild.cloneNode(true);
      video.autoplay = options.autoplay;
      video.muted = options.muted;
      video.loop = options.loop;
      video.controls = options.controls;
      video.playsInline = true;

      this.replaceChildren(video);
      video.play();
    }
  }

  customElements.define('video-block-player', VideoBlockPlayer);
  } catch(e) { console.error(e); }
})();

})();
